const translations = {
  en: {
    // Navbar
    navHome: "Home",
    navCountdown: "Countdown",
    navGallery: "Gallery",
    navRsvp: "RSVP",
    navFaq: "FAQ",
    navHotels: "Hotels",
    navRegistry: "Registry",

    // Hero
    heroFamilies: "Together with their families",
    heroPleasure: "Request the pleasure of your company",
    heroDate: "July 2nd, 2026",
    heroButton: "View Details",

    // Countdown
    countdownSave: "Save the Date",
    countdownHeading: "Counting Down",
    countdownDate: "July 2nd, 2026",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",

    // Gallery
    gallerySubtitle: "Captured moments",
    galleryHeading: "Photo Gallery",
    galleryDescription: "Share your favorite moments with us! Upload photos and download the ones you love.",
    galleryUpload: "Upload Photos",
    galleryDownload: "Download",
    galleryDelete: "Remove",
    galleryEmpty: "No photos yet. Be the first to share a moment!",
    galleryUploading: "Uploading...",

    // RSVP
    rsvpSubtitle: "We'd love to hear from you",
    rsvpHeading: "RSVP",
    rsvpDescription: "Please let us know if you'll be joining us on our special day.",
    rsvpName: "Full Name",
    rsvpNamePlaceholder: "Your full name",
    rsvpAttendLabel: "Will you attend?",
    rsvpAttending: "Joyfully Attending",
    rsvpNotAttending: "Regretfully Declining",
    rsvpPlusOne: "Plus One",
    rsvpPlusOneNote: "Only select yes if specified on your invitation",
    rsvpPlusOneYes: "Yes",
    rsvpPlusOneNo: "No",
    rsvpPlusOneName: "Plus One's Full Name",
    rsvpPlusOneNamePlaceholder: "Their full name",
    rsvpFoodChoice: "Meal Selection",
    rsvpFoodNote: "All meals include mashed potato and Caesar salad",
    rsvpFoodChicken: "Pan Seared Chicken",
    rsvpFoodSteak: "8 oz Petit Chateaubriand (cooked medium)",
    rsvpFoodVegetarian: "Vegetable Lasagna",
    rsvpPlusOneFoodChoice: "Plus One's Meal Selection",
    rsvpChildren: "Number of Children",
    rsvpChildrenNote: "Only include children 12 and under. All kids will receive chicken fingers and fries.",
    rsvpChildren0: "None",
    rsvpChildren1: "1 Child",
    rsvpChildren2: "2 Children",
    rsvpChildren3: "3 Children",
    rsvpDietary: "Dietary Restrictions",
    rsvpDietaryPlaceholder: "Any allergies or dietary needs",
    rsvpSubmit: "Send RSVP",
    rsvpThankYou: "Thank You!",
    rsvpReceived: (name) => `Your RSVP has been received, ${name}. We can't wait to celebrate with you!`,

    // FAQ
    faqSubtitle: "Common questions",
    faqHeading: "FAQ",
    faqQ1: "What time should I arrive?",
    faqA1: "Guests are kindly asked to arrive at least 20\u201330 minutes prior to the start of the ceremony to allow time for seating.",
    faqQ2: "Is parking available at the venue?",
    faqA2: "Complimentary parking will be available for all guests. Additional details may be found on the website.",
    faqQ3: "Are there hotel accommodations for guests?",
    faqA3Before: "We have reserved room blocks at two nearby hotels for our guests. Please visit the ",
    faqA3After: " tab for more information and booking details.",
    faqQ4: "May I bring a guest?",
    faqA4: "Due to venue capacity, we are only able to accommodate those guests formally listed on your invitation.",
    faqQ5: "Will the ceremony be unplugged?",
    faqA5: "We kindly request that guests refrain from using phones or cameras during the ceremony, and instead be fully present with us in the moment.",
    faqQ6: "Are gifts expected?",
    faqA6: "Your presence at our celebration is sincerely appreciated. Should you wish to honor us with a gift, a registry and honeymoon fund have been arranged. A card box will be available at the reception.",
    faqQ7: "Will there be alcohol?",
    faqA7: "Of course! We\u2019ll be treating everyone to drinks at the start\u2014after that, the party continues with a cash bar \ud83e\udd42",

    // Registry
    // Hotels
    hotelsSubtitle: "Where to stay",
    hotelsHeading: "Hotel Accommodations",
    hotelsDescription: "We have reserved room blocks at two nearby hotels for our guests. Guests can either book online or call the hotel and mention the Aquino Quinones wedding to receive the group rate. Please see the options below for booking details and special rates.",
    hotel1Name: "Cambria Hotel & Suites Plymouth",
    hotel1Rate: "$224 / night",
    hotel1Distance: "~20 minutes from wedding venue",
    hotel1Button: "Book Now",
    hotel2Name: "Residence Inn by Boston Bridgewater",
    hotel2Rate: "$259 / night",
    hotel2Distance: "~30 minutes from wedding venue",
    hotel2Button: "Book Now",

    // Registry
    registryHeading: "Gift Registry",
    registryDescription: "Your presence is the greatest gift of all. If you wish to celebrate us with a gift, we have created a registry for your convenience.",
    registryButtonAmazon: "Amazon Registry",
    registryButtonMacys: "Macy's Registry",

    // Footer
    footerDate: "July 2nd, 2026",
    footerMade: "Made with love",

    // Language picker
    langPickerTitle: "Welcome!",
    langPickerSubtitle: "Please select your preferred language",
    langEnglish: "English",
    langSpanish: "Español",
  },

  es: {
    // Navbar
    navHome: "Inicio",
    navCountdown: "Cuenta Regresiva",
    navGallery: "Galería",
    navRsvp: "Confirmar",
    navFaq: "Preguntas",
    navHotels: "Hoteles",
    navRegistry: "Regalos",

    // Hero
    heroFamilies: "Junto con sus familias",
    heroPleasure: "Solicitan el placer de su compañía",
    heroDate: "2 de julio de 2026",
    heroButton: "Ver Detalles",

    // Countdown
    countdownSave: "Reserva la Fecha",
    countdownHeading: "Cuenta Regresiva",
    countdownDate: "2 de julio de 2026",
    days: "Días",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",

    // Gallery
    gallerySubtitle: "Momentos capturados",
    galleryHeading: "Galería de Fotos",
    galleryDescription: "¡Comparte tus momentos favoritos con nosotros! Sube fotos y descarga las que más te gusten.",
    galleryUpload: "Subir Fotos",
    galleryDownload: "Descargar",
    galleryDelete: "Eliminar",
    galleryEmpty: "Aún no hay fotos. ¡Sé el primero en compartir un momento!",
    galleryUploading: "Subiendo...",

    // RSVP
    rsvpSubtitle: "Nos encantaría saber de ti",
    rsvpHeading: "Confirmar Asistencia",
    rsvpDescription: "Por favor, déjanos saber si nos acompañarás en nuestro día especial.",
    rsvpName: "Nombre Completo",
    rsvpNamePlaceholder: "Tu nombre completo",
    rsvpAttendLabel: "¿Asistirás?",
    rsvpAttending: "Asistiré con alegría",
    rsvpNotAttending: "Lamentablemente no podré asistir",
    rsvpPlusOne: "Acompañante",
    rsvpPlusOneNote: "Solo selecciona sí si está indicado en tu invitación",
    rsvpPlusOneYes: "Sí",
    rsvpPlusOneNo: "No",
    rsvpPlusOneName: "Nombre Completo del Acompañante",
    rsvpPlusOneNamePlaceholder: "Su nombre completo",
    rsvpFoodChoice: "Selección de Comida",
    rsvpFoodNote: "Todas las comidas incluyen puré de papa y ensalada César",
    rsvpFoodChicken: "Pollo a la Plancha",
    rsvpFoodSteak: "Petit Chateaubriand de 8 oz (término medio)",
    rsvpFoodVegetarian: "Lasaña de Vegetales",
    rsvpPlusOneFoodChoice: "Comida del Acompañante",
    rsvpChildren: "Número de Niños",
    rsvpChildrenNote: "Solo incluya niños de 12 años o menores. Todos los niños recibirán deditos de pollo con papas fritas.",
    rsvpChildren0: "Ninguno",
    rsvpChildren1: "1 Niño",
    rsvpChildren2: "2 Niños",
    rsvpChildren3: "3 Niños",
    rsvpDietary: "Restricciones Alimentarias",
    rsvpDietaryPlaceholder: "Alergias o necesidades dietéticas",
    rsvpSubmit: "Enviar Confirmación",
    rsvpThankYou: "¡Gracias!",
    rsvpReceived: (name) => `Tu confirmación ha sido recibida, ${name}. ¡No podemos esperar para celebrar contigo!`,

    // FAQ
    faqSubtitle: "Preguntas frecuentes",
    faqHeading: "Preguntas Frecuentes",
    faqQ1: "\u00bfA qué hora debo llegar?",
    faqA1: "Se les pide amablemente a los invitados que lleguen al menos 20\u201330 minutos antes del inicio de la ceremonia para permitir tiempo de acomodarse.",
    faqQ2: "\u00bfHay estacionamiento disponible en el lugar?",
    faqA2: "Habrá estacionamiento gratuito disponible para todos los invitados. Se pueden encontrar detalles adicionales en el sitio web.",
    faqQ3: "\u00bfHay alojamiento para los invitados?",
    faqA3Before: "Hemos reservado bloques de habitaciones en dos hoteles cercanos para nuestros invitados. Por favor visite la pestaña de ",
    faqA3After: " para más información y detalles de reservación.",
    faqQ4: "\u00bfPuedo traer un acompañante?",
    faqA4: "Debido a la capacidad del lugar, solo podemos acomodar a los invitados formalmente incluidos en su invitación.",
    faqQ5: "\u00bfLa ceremonia será sin dispositivos?",
    faqA5: "Pedimos amablemente que los invitados se abstengan de usar teléfonos o cámaras durante la ceremonia, y en su lugar estén completamente presentes con nosotros en el momento.",
    faqQ6: "\u00bfSe esperan regalos?",
    faqA6: "Su presencia en nuestra celebración es sinceramente apreciada. Si desea honrarnos con un regalo, se ha organizado un registro y un fondo de luna de miel. Habrá una caja para tarjetas disponible en la recepción.",
    faqQ7: "\u00bfHabrá alcohol?",
    faqA7: "\u00a1Por supuesto! Invitaremos a todos con bebidas al inicio\u2014después, la fiesta continúa con barra de pago \ud83e\udd42",

    // Registry
    // Hotels
    hotelsSubtitle: "Dónde hospedarse",
    hotelsHeading: "Alojamiento",
    hotelsDescription: "Hemos reservado bloques de habitaciones en dos hoteles cercanos para nuestros invitados. Pueden reservar en línea o llamar al hotel y mencionar la boda Aquino Quinones para recibir la tarifa de grupo. A continuación encontrarán los detalles de reservación y tarifas especiales.",
    hotel1Name: "Cambria Hotel & Suites Plymouth",
    hotel1Rate: "$224 / noche",
    hotel1Distance: "~20 minutos del lugar de la boda",
    hotel1Button: "Reservar",
    hotel2Name: "Residence Inn by Boston Bridgewater",
    hotel2Rate: "$259 / noche",
    hotel2Distance: "~30 minutos del lugar de la boda",
    hotel2Button: "Reservar",

    // Registry
    registryHeading: "Registro de Regalos",
    registryDescription: "Su presencia es el mayor regalo de todos. Si desea celebrarnos con un regalo, hemos creado un registro para su conveniencia.",
    registryButtonAmazon: "Registro en Amazon",
    registryButtonMacys: "Registro en Macy's",

    // Footer
    footerDate: "2 de julio de 2026",
    footerMade: "Hecho con amor",

    // Language picker
    langPickerTitle: "¡Bienvenidos!",
    langPickerSubtitle: "Por favor selecciona tu idioma preferido",
    langEnglish: "English",
    langSpanish: "Español",
  },
};

export default translations;
